import React from "react";
import _ from "lodash";

import FluserUser from "../components/FluserUser";

import { dotted_line } from "../../../assets/images/fluster";
import { exclamation1 } from "../../../assets/images/fluster";
import { exclamation2 } from "../../../assets/images/fluster";
import { exclamation3 } from "../../../assets/images/fluster";

const Result = ({
  parameters,
  average_points,
  answerer_player_details,
  status,
  aroundthehorn_winner_player_details,
  asker_player_details,
}) => {
  const info_1 = _.get(parameters, "7_flusterresult.info_1", " has recieved ");
  const info_2 = _.get(parameters, "7_flusterresult.info_2", " points");
  const ath_info_1 = _.get(
    parameters,
    "10_aroundthehornresult.info_1",
    " liked "
  );
  const ath_info_2 = _.get(
    parameters,
    "10_aroundthehornresult.info_2",
    " answer Best! "
  );
  const ath_info_3 = _.get(
    parameters,
    "10_aroundthehornresult.info_3",
    " is the new Asker! "
  );

  const answerer_display_name = _.get(answerer_player_details, "display_name");
  const answerer_profile_image = _.get(
    answerer_player_details,
    "profile_image"
  );
  const asker_display_name = _.get(asker_player_details, "display_name");
  const asker_profile_image = _.get(asker_player_details, "profile_image");

  const aroundthehorn_winner_display_name = _.get(
    aroundthehorn_winner_player_details,
    "display_name"
  );
  const aroundthehorn_winner_profile_image = _.get(
    aroundthehorn_winner_player_details,
    "profile_image"
  );

  const get_points_image = (average_points) => {
    switch (average_points) {
      case 1:
        return (
          <>
            {" "}
            <img src={exclamation1} />
          </>
        );
      case 2:
        return (
          <>
            {" "}
            <img src={exclamation2} />
          </>
        );
      case 3:
        return (
          <>
            {" "}
            <img src={exclamation3} />
          </>
        );
    }
  };

  return (
    <div className="asker-main-content voting-result">
      <div className="top-content">
        <div className="left-content">
          {status === "AroundTheHornResult" ? (
            <FluserUser
              display_name={aroundthehorn_winner_display_name}
              profile_image={aroundthehorn_winner_profile_image}
            />
          ) : status === "FlusterResult" ? (
            <FluserUser
              display_name={asker_display_name}
              profile_image={asker_profile_image}
            />
          ) : (
            <FluserUser
              display_name={answerer_display_name}
              profile_image={answerer_profile_image}
            />
          )}
        </div>
        <div className="middle-content">
          <img src={dotted_line} alt="" />
        </div>
        <div className="right-content">
          {status === "AroundTheHornResult" ? (
            <div className="around_horn_info">
              <p>
                <span>{answerer_display_name}</span> {ath_info_1}{" "}
                <span>{aroundthehorn_winner_display_name}'s</span> {ath_info_2}{" "}
              </p>
              <br></br>
              <p>
                <span>{aroundthehorn_winner_display_name}</span> {ath_info_3}
              </p>
            </div>
          ) : status === "FlusterResult" ? (
            <div>
              <p>
                {asker_display_name}
                <br /> {info_1}
                {average_points} {info_2}
                <br />
                <br />
                {get_points_image(average_points)}
              </p>
              
            </div>
            
          ) : (
            <div>
              <p>
                {answerer_display_name}
                <br /> {info_1}
                {average_points} {info_2}
                <br />
                <br />
                {get_points_image(average_points)}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Result;
